import React from 'react';
import ReactDOM from 'react-dom';

import App from './components/App';
import * as serviceWorker from './serviceWorker';
import store from './store';
import { Provider } from "react-redux";
import appHistory from './utilities/history';
import Router from './routes';
import './index.scss';
ReactDOM.render(
  <Provider store={store}>
     <Router component={App} history={appHistory} />
  </Provider>,
  document.getElementById('root')
);






// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
